import styled from "styled-components";

export const StyledActionCell = styled.div`
    align-items: center;
    display: flex;
    height: 100%;
`;

export const SecondStagedCell = styled.div`
    && {
        display: flex;
        height: 40px;
        flex-direction: column;
        font-size: 12px;
        margin-top: -4px;
        line-height: 1.2;
        margin-left: 4px;
    }
`;
